import { IApplicationState } from '../../types/redux';
import { IMarkedListTextBlock } from '../../types/seo';

export const selectMarkedListItems = (state: IApplicationState): IMarkedListTextBlock[] => {
  return state.seo.markedList?.items || [];
};
